// extracted by mini-css-extract-plugin
export default {"suggestions":"GoalEffects_suggestions__2WKZ9"};